import { get } from 'lodash';

function hasConsent(contact) {
  return get(contact, 'consent.state') === 'accepted';
}

export default hasConsent;
